import { useCallback, useMemo } from 'react';
import { ScreenableFieldPart } from './useUsableFieldsBuilder';

export const useTableNestedHack = (
  allFields: Map<string, ScreenableFieldPart>,
  selectedFields: ScreenableFieldPart[],
  setSelectedFields: (fields: ScreenableFieldPart[]) => void
) => {
  const fieldsAvailableInTable = useMemo(() => Array.from(allFields.values()), [allFields]);
  const fieldsActiveInTable = useMemo(
    () => selectedFields.filter((field) => fieldsAvailableInTable.includes(field)),
    [selectedFields, fieldsAvailableInTable]
  );

  const setFieldsFromTable = useCallback(
    (tableNewFields: ScreenableFieldPart[]) => {
      const removedFields = selectedFields
        .filter((field) => fieldsAvailableInTable.includes(field))
        .filter((field) => !tableNewFields.includes(field));
      const addedFields = tableNewFields.filter((field) => !selectedFields.includes(field));
      setSelectedFields([...selectedFields.filter((field) => !removedFields.includes(field)), ...addedFields]);
    },
    [selectedFields, fieldsAvailableInTable]
  );

  const toggleField = useCallback(
    (field: ScreenableFieldPart) => {
      if (selectedFields.map((f) => f.id).includes(field.id)) {
        setSelectedFields(selectedFields.filter((f) => f.id !== field.id));
      } else {
        setSelectedFields([...selectedFields, field]);
      }
    },
    [allFields, selectedFields]
  );
  return [fieldsAvailableInTable, fieldsActiveInTable, setFieldsFromTable, toggleField] as const;
};
